var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconGridLayout = function SvgIconGridLayout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.18h6.68V4.5H4.5zm0 8.32h6.68v-6.68H4.5zm8.32 0h6.68v-6.68h-6.68zm0-15v6.68h6.68V4.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconGridLayout);
export { ForwardRef as ReactComponent };